import React from "react";
import styled from "styled-components";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaEnvelope,
  FaPhone,
} from "react-icons/fa";
import colors from "../colors";

const FooterContainer = styled.footer`
  background-color: ${colors.darkPurple};
  color: #fff;
  padding: 60px 0 20px;
`;

const FooterWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 30px;
  padding: 0 50px;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterLogo = styled.a`
  color: #fff;
  font-size: 1.5rem;
  display: inline-block;
  margin-bottom: 16px;
  font-weight: bold;
  text-decoration: none;
  background: ${colors.gradientPrimary};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const FooterDescription = styled.p`
  margin-bottom: 20px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
`;

const FooterTitle = styled.h4`
  font-size: 18px;
  margin-bottom: 16px;
  font-weight: bold;
`;

const FooterLink = styled.a`
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  margin-bottom: 10px;
  display: block;
  transition: 0.3s ease-out;

  &:hover {
    color: ${colors.skyBlue};
    transition: 0.3s ease-out;
    transform: translateX(5px);
  }

  @media screen and (max-width: 768px) {
    &:hover {
      transform: none;
    }
  }
`;

const SocialIcons = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 16px;

  @media screen and (max-width: 768px) {
    justify-content: center;
  }
`;

const SocialIconLink = styled.a`
  color: #fff;
  font-size: 24px;
  margin-right: 20px;
  transition: 0.3s ease-out;

  &:hover {
    color: ${colors.skyBlue};
    transform: translateY(-2px);
    transition: 0.3s ease-out;
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  svg {
    margin-right: 10px;
    color: ${colors.skyBlue};
  }

  @media screen and (max-width: 768px) {
    justify-content: center;
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterWrapper>
        <FooterColumn>
          <FooterLogo href="/">IADEVENDA</FooterLogo>
          <FooterDescription>
            Democratizar o poder da IA para que qualquer empresa venda mais, de
            forma rápida e inteligente.
          </FooterDescription>
          <SocialIcons>
            {/* <SocialIconLink href="/" aria-label="Facebook">
              <FaFacebook />
            </SocialIconLink> */}
            {/* <SocialIconLink href="/" aria-label="Twitter">
              <FaTwitter />
            </SocialIconLink> */}
            <SocialIconLink
              href="https://www.instagram.com/iadevenda/#"
              aria-label="Instagram"
              target="_blank"
            >
              <FaInstagram />
            </SocialIconLink>
            {/* <SocialIconLink href="/" aria-label="LinkedIn">
              <FaLinkedin />
            </SocialIconLink> */}
          </SocialIcons>
        </FooterColumn>

        <FooterColumn>
          <FooterTitle>Empresa</FooterTitle>
          <FooterLink href="/">Sobre nós</FooterLink>
          {/* <FooterLink href="/">Carreiras</FooterLink>
          <FooterLink href="/">Blog</FooterLink>
          <FooterLink href="/">Parceiros</FooterLink> */}
        </FooterColumn>

        {/* <FooterColumn>
          <FooterTitle>Recursos</FooterTitle>
          <FooterLink href="/">Academy</FooterLink>
          <FooterLink href="/">Documentação</FooterLink>
          <FooterLink href="/">Afiliados</FooterLink>
          <FooterLink href="/">Suporte</FooterLink>
        </FooterColumn> */}

        <FooterColumn>
          <FooterTitle>Contato</FooterTitle>
          {/* <ContactItem>
            <FaEnvelope />
            <span>contato.iadevenda@gmail.com</span>
          </ContactItem> */}
          <ContactItem>
            <FaPhone />
            <span>+55 (11) 5286-8938</span>
          </ContactItem>
        </FooterColumn>
      </FooterWrapper>

      <Copyright>
        © {new Date().getFullYear()} IADEVENDA. Todos os direitos reservados.
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
